import { useContext, useEffect, useMemo, useState } from 'react'

import {
  Box,
  Button,
  Input,
  Modal,
  Select,
  SelectOption,
  Text,
} from '@fairfashion/design-system'
import { Controller, useForm } from 'react-hook-form'

import { GlobalDataContext } from '../../contexts/globalData'
import { ICompanySegmentAlias } from '../../sdk/company/company.types'
import { sdk } from '../../services/sdk'

import {
  CompanyDataForm,
  EditCompanyModalProps,
} from './edit-company-modal.types'

export const EditCompanyModal = ({
  title,
  data,
  open,
  onClose,
  onSubmit,
}: EditCompanyModalProps) => {
  const [segmentsOptions, setSegmentsOptions] = useState<SelectOption[]>([])

  const { register, control, reset, handleSubmit } = useForm<CompanyDataForm>()

  const { companySegmentType } = useContext(GlobalDataContext)

  const fetchSegments = async () => {
    const _response = await sdk.company.getSegments()
    setSegmentsOptions(
      _response.map((segment) => ({
        label: segment.translate,
        value: segment.name,
      })),
    )
  }

  useEffect(() => {
    fetchSegments()

    if (data) {
      reset({
        name: data.name,
        taxId: data.taxId,
        segment: data.segment,
      })
    }
  }, [data])

  const submitForm = async (data: CompanyDataForm) => {
    if (onSubmit) {
      await onSubmit(data)
      onClose()
    }
  }

  const segment = useMemo(() => {
    if (!companySegmentType) return {} as ICompanySegmentAlias

    return companySegmentType[data?.segment ?? 'fashion_company']
  }, [companySegmentType, data?.segment])

  const allowEditSegment = useMemo(() => {
    return data?.segment !== 'fashion_company' && data?.segment !== 'blockforce'
  }, [data?.segment])

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      width="830px"
      maxWidth="90%"
    >
      {open && (
        <form onSubmit={handleSubmit(submitForm)}>
          <Box width="100%" direction="column" gap={3}>
            <Text size="small" fontWeight={500}>
              Dados da empresa
            </Text>

            <Box width="100%" flexWrap="wrap" gap={2}>
              <Box flex={1} minWidth="120px">
                <Input {...register('name')} disabled label="Nome" />
              </Box>
              <Box flex={1} minWidth="120px">
                <Input {...register('taxId')} disabled label="CNPJ" />
              </Box>

              <Controller
                control={control}
                name="segment"
                render={({ field }) => {
                  return (
                    <Select
                      options={segmentsOptions}
                      label="Segmento"
                      placeholder={segment?.translate}
                      disabled={!allowEditSegment}
                      {...field}
                    />
                  )
                }}
              />
            </Box>

            <Box width="100%" justifyContent="flex-end" gap={2}>
              <Button variant="outlined" onClick={onClose}>
                Cancelar
              </Button>
              <Button type="submit">Salvar</Button>
            </Box>
          </Box>
        </form>
      )}
    </Modal>
  )
}
